// extracted by mini-css-extract-plugin
export var bodyRow = "_d4-d";
export var cardColumns = "_d4-e";
export var ellipsesOverflow = "_d4-2";
export var flatBottomCorners = "_d4-3";
export var flatTopCorners = "_d4-4";
export var headerActionsDropdown = "_d4-f";
export var headerBottomRow = "_d4-c";
export var headerTopRow = "_d4-b";
export var orderDetailsWrapper = "_d4-0";
export var orderInfoContainer = "_d4-1";
export var productDetails = "_d4-9";
export var productImage = "_d4-5";
export var responsiveTable = "_d4-8";
export var shipmentContainer = "_d4-a";
export var tableBottomLeft = "_d4-6";
export var tableBottomRight = "_d4-7";
export var trackingLink = "_d4-g";